import React from 'react';
import { SvgIconProps } from '../types';

export default function Adult({
  fill,
  width,
  height,
  className,
  ariaLabel,
  ariaHidden,
}: SvgIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      fill="none"
      width={width}
      height={height}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <g clip-path="url(#clip0_20708_74867)">
        <path
          d="M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z"
          fill={fill}
        />
        <path
          d="M10.673 20.47C12.4766 20.47 13.9387 19.0079 13.9387 17.2044C13.9387 15.4008 12.4766 13.9387 10.673 13.9387C8.86948 13.9387 7.40741 15.4008 7.40741 17.2044C7.40741 19.0079 8.86948 20.47 10.673 20.47Z"
          fill="white"
        />
        <path
          d="M39.4896 20.5263C41.4673 20.5263 43.0705 18.9231 43.0705 16.9454C43.0705 14.9677 41.4673 13.3645 39.4896 13.3645C37.5119 13.3645 35.9087 14.9677 35.9087 16.9454C35.9087 18.9231 37.5119 20.5263 39.4896 20.5263Z"
          fill="white"
        />
        <path
          d="M38.6931 27.3197C38.6931 27.3197 37.8269 33.1341 37.1598 36.559C37.1598 36.559 29.0223 35.9152 28.7966 31.5511C28.707 29.8453 30.768 25.2223 31.81 22.5341C31.81 22.5341 30.2303 20.7353 26.8419 20.211C24.4325 19.8393 23.3771 19.1092 23.6094 17.9509C23.8418 16.7927 24.8805 16.6898 26.6195 16.9088C29.1252 17.2208 32.4771 17.6755 37.276 21.3261C40.5947 23.8516 43.2663 28.2589 44.023 31.0732C44.4644 32.7193 44.3947 33.8178 43.3957 34.1231C41.9886 34.5579 41.2352 33.5888 40.8967 32.1186C40.4487 30.1539 39.7484 28.8131 38.6864 27.3164L38.6931 27.3197Z"
          fill="white"
        />
        <path
          d="M22.2289 20.1015C22.5209 20.0152 22.803 19.9987 23.0553 19.9389C22.9524 19.8327 22.8594 19.7232 22.7765 19.6037C22.3782 19.0362 22.2455 18.3592 22.3882 17.649C22.4247 17.4598 22.4844 17.264 22.5674 17.0715C22.5143 17.0782 22.4645 17.0815 22.4114 17.0881C20.1281 17.3901 17.0749 17.8249 12.7207 21.1868C9.71064 23.5132 7.05565 27.6384 6.38527 30.2104C5.99366 31.7138 6.06667 32.716 6.976 32.9882C8.26367 33.3731 8.76148 32.4339 9.23938 31.143C9.91972 29.311 10.6731 28.2888 11.526 26.8917C11.526 26.8917 12.3026 31.9594 12.9298 35.0756C12.9298 35.0756 20.3472 34.4318 20.5231 30.4527C20.5928 28.8962 18.5882 24.4358 17.6192 21.9899C17.6192 21.9899 19.2819 20.9677 22.2289 20.0982V20.1015Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_20708_74867">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
